import styled from 'styled-components';

export const EmbedReferenceContainer = styled.div`
  display: flex;
  max-width: 100%;
  height: 600px;
  overflow: hidden;
`;

export const PlaceholderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const PreviewContainer = styled.div`
  margin-left: 10px;
  margin-right: 8px;
  min-height: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-bottom: 10px;
`;

export const PreviewPlaceholderHeaderText = styled.p`
  font-size: 20px;
  font-weight: 500;
  line-height- 24px;
  text-align: center;
  width: 400px;
`;

export const ValueContainer = styled.div`
  margin-top: 30px;
  margin-left: 15px;
`;

export const PreviewPlaceholderText = styled.p`
  font-size: 14px;
  font-weight: 400;
  width: 240px;
  text-align: center;
`;
